var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgWeb = function SvgWeb(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 17",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 16.5H2q-.824 0-1.412-.587A1.93 1.93 0 0 1 0 14.5v-12q0-.825.588-1.412A1.92 1.92 0 0 1 2 .5h16q.825 0 1.413.588Q20 1.675 20 2.5v12q0 .825-.587 1.413A1.93 1.93 0 0 1 18 16.5M2 4.5v10h16v-10z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWeb);
export { ForwardRef as Icon };
export default "img/element-icons/settings/web.59c702a.svg";